import { CmsPage } from './cms.component';
import { connect } from 'react-redux';
import { fetchCms } from "./../../api/cms/cmsAction";

const mapDispatchToProps = {
    fetchCms
};

const mapStateToProps = state => ({
    isLoading: state.cmsPage.isLoading,
    cms: state.cmsPage.cms
});

export const CmsContainer = connect(mapStateToProps, mapDispatchToProps)(CmsPage);